import {
  FramingChoice,
  FramingProduct,
  FramingSelection,
  FramingSelections,
} from '../types';
import { resolveChoiceForProduct } from './framePricing';

/**
 * Apply a confirmed framing choice to a set of selections. `applyToAll`
 * targets every product; otherwise `targetIds` (or all products when empty).
 *
 * On a broad apply (all products targeted), a product that can't offer the
 * chosen style resolves to `undefined`; its existing selection is kept instead
 * of dropping it back to pending.
 */
export const applyChoiceToSelections = ({
  applyToAll = false,
  choice,
  previous,
  products,
  targetIds,
}: {
  products: FramingProduct[];
  previous: FramingSelections;
  choice: FramingChoice;
  targetIds: string[];
  applyToAll?: boolean;
}): FramingSelections => {
  const next: FramingSelections = { ...previous };
  const allIds = products.map((product) => product.id);
  const scopedIds = targetIds.length > 0 ? targetIds : allIds;
  const targetIdSet = new Set(applyToAll ? allIds : scopedIds);
  const targets = products.filter((product) => targetIdSet.has(product.id));
  const isBroadApply = applyToAll || scopedIds.length === allIds.length;

  targets.forEach((product) => {
    const resolved: FramingSelection = resolveChoiceForProduct(product, choice);
    next[product.id] =
      resolved === undefined && isBroadApply ? next[product.id] : resolved;
  });

  return next;
};
